import { WebAuth } from 'auth0-js';

;(function (window, document, undefined) {

    window.gembaAuth0 = window.gembaAuth0 || {};
    window.gembaAuth0.logOut = function(config) {

      //handle cookies
      document.cookie.split(';').forEach(function (cookie) {
        const name = cookie.split('=')[0].trim();
        if (/^_?(com\.auth0\.auth\.|co\/verifier\/)/.test(decodeURIComponent(name))) {
          //delete
          document.cookie = name + "=;max-age=-1;path=/;";
        }
      });

      let webAuth = new WebAuth({
        domain: config.domain,
        clientID: config.clientId,
      });

      webAuth.logout({
        returnTo: config.returnTo,
        client_id: config.clientId,
      });
    };
})(window, document);
